import { Suspense } from 'react';
import { ROUTES } from '@/common/constants/routes';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { safeLazy } from '@/common/utils/import';
import { LoadingPlaceholder } from '@/web/components/LoadingPlaceholder/LoadingPlaceholder';
import { Redirect } from 'expo-router';

const { AIGeniusHome } = safeLazy(
  () => import('@/web/containers/AIGenius/AIGeniusHome/AIGeniusHome')
);

export default function CoverflexAIPage() {
  const {
    features: { ff_employee_coverflex_ai },
    isLoading,
  } = useFeatures();

  if (isLoading) {
    return <LoadingPlaceholder />;
  }

  if (!ff_employee_coverflex_ai) {
    return <Redirect href={ROUTES.NOT_FOUND} />;
  }

  return (
    <Suspense fallback={<LoadingPlaceholder />}>
      <AIGeniusHome />
    </Suspense>
  );
}
